exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nhr[data-v-3a76a0d8]{border-color:gray\n}", ""]);

// exports
